import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { PartnerCustomerSearchResponse } from '../models/customer.model';

@Injectable({
    providedIn: 'root'
})
export class CustomerService {
    private apiUrl = `${environment.apiConfig.uri}/api/Partner/customers`;

    constructor(private http: HttpClient) { }

    /**
     * Search for customers by name or phone number
     * @param searchTerm - Customer name or phone number
     * @param pageIndex - Page index (default: 0)
     * @param pageSize - Page size (default: 10)
     * @returns Observable of paginated customer search results
     */
    searchCustomers(
        searchTerm: string,
        pageIndex: number = 0,
        pageSize: number = 10
    ): Observable<PartnerCustomerSearchResponse> {
        let params = new HttpParams()
            .set('searchTerm', searchTerm)
            .set('pageIndex', pageIndex.toString())
            .set('pageSize', pageSize.toString());

        return this.http.get<PartnerCustomerSearchResponse>(`${this.apiUrl}/search`, { params });
    }
}
